import React from "react";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import './register.css';
import ConfirmationDialog from "../header/confirmation.dialog";
import { submitRegisterAdd, UserDto } from "../../services/home.service";
import withRouter from "../../common/with-router";
import { SnackbarUI, useSnackbar } from "../header/snackbarProvider";
import { FaEnvelope, FaMapPin, FaPhone, FaUser, FaRegLightbulb } from "react-icons/fa";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
const RegisterComponent = (props) => {

  const { showSnackbar, snackbar } = useSnackbar();

  const { router } = props;
  const { navigate } = router;
  const [loginId, setLoginId] = useState("");

  const [initialValues, setInitialValues] = useState({
    name: "",
    phone: "",
    emailId: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [dialogValues, setDialogValues] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);




  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, "Name should contain only letters")
      .min(2, "Name must be at least 2 characters long")
      .max(100, "Name cannot exceed 100 characters")
      .required("Please enter your name"),

    phone: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
      .required("Please enter your mobile number"),

    emailId: Yup.string()
      .email("Enter a valid email address")
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, "Invalid email format")
      .required("Please enter your email"),


  });


  const handleRegisterSubmit = async (values, { setSubmitting, validateForm }) => {
    // Trigger form validation
    const errors = await validateForm();
    // Check if there are validation errors
    if (Object.keys(errors).length > 0) {
      setSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    setOpenConfirmationDialog(true);
    setDialogValues(values);
  };


  const handleDialogClose = () => {
    setOpenConfirmationDialog(false);
    setIsSubmitting(false); // Re-enable submit button
  };


  const handleDialogConfirm = async () => {
    setOpenConfirmationDialog(false);

    if (isSubmitting) {
      setIsLoading(true); // Set loading state to true
      setShowLoadingModal(true); // Show loading popup

      try {
        // Call the submit form function and get the response
        const result = await submitRegisterForm(dialogValues);

        // Handle the response after submission
        if (result.success) {
          const message = result.message;
          setShowLoadingModal(false); // Hide loading modal
          setInitialValues({
            name: "",
            phone: "",
            emailId: "",
          });


          navigate("/login", {
            state: {
              snackbarMessage: message,
              snackbarSeverity: "success",
            },
          });



        } else {
          showSnackbar(result.message, "danger");
          setShowLoadingModal(false);
        }

      } catch (error) {
        console.error("Error in handleDialogConfirm:", error);
        showSnackbar("An error occurred during registration", "danger");
        setShowLoadingModal(false);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const submitRegisterForm = async (values) => {
    const userDto = new UserDto(
      loginId || "", // Ensure loginId is assigned correctly
      values.emailId, // Email as username
      "", // Password (handle this if required)
      values.name,
      values.emailId, // Email
      values.phone,
      "" // Role (if required)
    );

    try {
      // Call the API for registration and get the response
      const response = await submitRegisterAdd(userDto);

      if (response && response.includes("User registration successful")) {
        return {
          success: true,
          message: "User registration successful. Please log in.",
        };
      } else if (response && response.includes("Email already exists")) {
        return {
          success: false,
          message: "Email already exists",
        };
      } else {
        return {
          success: false,
          message: response || "An unknown error occurred",
        };
      }

    } catch (error) {
      console.error("Error occurred in submitRegisterForm:", error);
      return {
        success: false,
        message: "Error occurred during registration",
      };
    }
  };



  return (
    <>
      <Helmet>
        <title>REGISTER SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <HeaderComponent />
      <NavbarComponent />
      <section id="fixed-sub-nav" className="gradient-background" style={{ paddingBottom: '30px', paddingTop: '30px' }}>
        <div className="container pt-4 register-wrap">
          {/* <h3 className="text-center mb-4 register-main-title">Join SMART</h3> */}
          <div className="row register-row">


            <div className="col-lg-6 mb-0  register-form">
              <div className="card text-black form-card-register">
                <div className="card-body p-md-5">
                  <p className="text-center h2 fw-bold mb-2 pb-4 form-name">Join SMART Membership</p>

                  {/* Render the Snackbar UI here at the top of the page */}
                  {snackbar.open && <SnackbarUI message={snackbar.message} type={snackbar.type} />}

                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    enableReinitialize
                    onSubmit={handleRegisterSubmit}
                  >
                    {({ values, touched, errors, setFieldValue }) => (
                      <Form>
                        {/* Name Field */}
                        <div className="mb-3">
                          <div className="form-floating">
                            <Field
                              type="text"
                              id="name"
                              name="name"
                              className={`form-control ${touched.name && errors.name ? "is-invalid" : ""}`}
                              placeholder="Name"
                              maxLength={100}
                              onInput={(e) => {
                                // Allow letters, spaces, hyphens, apostrophes, and periods
                                e.target.value = e.target.value.replace(/[^A-Za-z\s\.\'\-]/g, "");
                              }}
                            />
                            <label htmlFor="name">
                              <FaUser className="me-2" />Name<span className="required-input">*</span>
                            </label>
                            <ErrorMessage name="name" component="div" className="invalid-feedback" />
                          </div>
                        </div>

                        {/* Mobile No Field */}
                        <div className="mb-3">
                          <div className="form-floating">
                            <Field
                              type="text"
                              id="phone"
                              name="phone"
                              className={`form-control ${touched.phone && errors.phone ? "is-invalid" : ""}`}
                              placeholder="Mobile No"
                              maxLength={10}
                              onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))} // Removes non-numeric characters
                            />
                            <label htmlFor="phone">
                              <FaPhone className="me-2" />Mobile No<span className="required-input">*</span>
                            </label>
                            <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                          </div>
                        </div>

                        {/* Email Field */}
                        <div className="mb-3">
                          <div className="form-floating">
                            <Field
                              type="email"
                              id="emailId"
                              name="emailId"
                              className={`form-control ${touched.emailId && errors.emailId ? "is-invalid" : ""}`}
                              placeholder="Email Address"
                              maxLength={100}
                            />
                            <label htmlFor="emailId">
                              <FaEnvelope className="me-2" />Email Address <span className="required-input">*</span>
                            </label>
                            <ErrorMessage name="emailId" component="div" className="invalid-feedback" />
                          </div>
                        </div>


                        {/* Submit Button */}
                        <div className="d-flex justify-content-center mt-4 pt-3">
                          <button type="submit" className="btn btn-lg w-100 register-button">
                            Join
                          </button>
                        </div>



                      </Form>
                    )}
                  </Formik>

                  <p className="text-center mb-4 mt-4">
                    Already Joined?{" "}
                    <a href="/login" className="login-link">Please Login</a>
                  </p>

                  <ConfirmationDialog
                    open={openConfirmationDialog}
                    onClose={handleDialogClose}
                    onConfirm={handleDialogConfirm}
                    title=""
                    message="Are you sure to submit?"
                  />



                  <div className="alert-container">
                    <div className="alert-content">
                      <strong>Notice:</strong> After registering, please check your email for your password.
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="card col-lg-6 mb-0 order-2 p-4 register-para">
              <div className="description-content h-100">
                <div className="d-flex flex-column h-100" style={{ fontSize: '20px' }}>
                  <div className="mt-5">
                    <p className="description-text justify-left">
                      Society for Microwaves, Antennas, and Radar Technologies (SMART) society is dedicated to fostering innovation and promoting collaboration in
                      these advanced fields. It's objective is to bring together scientists, engineers,
                      academicians, industry leaders, and young professionals on a shared platform to
                      facilitate brainstorming, knowledge exchange, and a deeper understanding of
                      pioneering radar technologies and national requirements.
                    </p>
                     <br/>
                    <p className="description-text justify-left">
                      We are pleased to announce the launch of the Professional Membership Drive
                      2025 for SMART! This is a great opportunity for professionals in the field of
                      Microwaves, Antennas and Radar Technologies to become part of a leading
                      Society dedicated to advancing knowledge, fostering collaboration, and
                      supporting career growth.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-4 mt-3" style={{ fontSize: '20px' }}>
            <div className="col-12 col-md-6 d-flex">
             <div className="card section-highlight p-4 w-100 h-100 shadow-card" style={{background:'#cbebfa'}}>
                <h4 className="section-title">
                  <FaMapPin className="pin-icon" /> Why Join?
                </h4>

                <ul className="benefits-list">
                  <li className="benefits-li benefits-sub-li" >
                    As a member, you will receive:
                  </li>
                  <li className="benefits-li">
                    <span className="benefit-icon">< HiOutlineArrowNarrowRight className="pin-icon" /></span> Access to exclusive professional development programs.
                  </li>
                  <li className="benefits-li">
                    <span className="benefit-icon">< HiOutlineArrowNarrowRight className="pin-icon" /></span> Invitations to member-only events, conferences & webinars at discounted rates.
                  </li>
                  <li className="benefits-li">
                    <span className="benefit-icon">< HiOutlineArrowNarrowRight className="pin-icon" /></span> Networking opportunities with industry leaders and peers.
                  </li>
                  <li className="benefits-li">
                    <span className="benefit-icon">< HiOutlineArrowNarrowRight className="pin-icon" /></span> The chance to contribute to the professional growth and impact on career progression.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex">
              <div className="card section-highlight p-4 w-100 h-100 shadow-card" style={{background:'antiquewhite'}}>
                <h4 className="section-title">
                  <FaMapPin className="pin-icon" /> Here's how you can get Benefitted:
                </h4>

                <ul className="benefits-list">
                  <li className="benefits-li">
                    <span className="benefit-icon ">< HiOutlineArrowNarrowRight className="pin-icon" /> </span> <strong className="benefits-sub-li">Become a Member:</strong> Your participation will help build a strong foundation
                    for the R&D efforts in Radar Technologies.
                  </li>
                  <li className="benefits-li">
                    <span className="benefit-icon"><HiOutlineArrowNarrowRight className="pin-icon" /> </span> <strong className="benefits-sub-li">Lead a Technical:</strong> We visualize forming specialized technical groups
                    focused on Microwaves, Antennas and Radar Technologies.
                  </li>
                </ul>
              </div>
            </div>
          </div>


          <div className="col-lg-12 mt-4 mb-0 order-3 eligibility-description">
            <div className="section-highlight">
              <h4 className="section-title">
                <FaMapPin className="pin-icon" /> Eligibility for Membership/Fellows:
              </h4>
              <div className="table-responsive eligibility-table shadow-card" style={{fontSize:'18px'}}>
                <table className="table table-hover align-middle">
                  <thead className="table-header eligibility-label-header">
                    <tr>
                      <th className="serial-number">SN</th>
                      <th>Membership Type</th>
                      <th >Eligibility Criteria</th>
                      <th className="text-end">Amount (INR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="serial-number">1</td>
                      <td>Annual Student Member</td>
                      <td className="justify-left">Individuals currently enrolled in accredited institutions pursuing a degree or diploma in Engineering, Technology, or a related Bachelor's program.</td>
                      <td className="text-end">₹500</td>
                    </tr>
                    <tr>
                      <td className="serial-number">2</td>
                      <td>Annual Member</td>
                      <td className="justify-left">Individuals holding a degree or diploma in Engineering, Technology, or a related Bachelor's qualification.</td>
                      <td className="text-end">₹1000</td>
                    </tr>
                    <tr>
                      <td className="serial-number">3</td>
                      <td>Life Member</td>
                      <td className="justify-left">Individuals holding a degree or diploma in Engineering, Technology, or a related Bachelor's qualification.</td>
                      <td className="text-end">₹5000</td>
                    </tr>
                    <tr>
                      <td className="serial-number">4</td>
                      <td>Life Senior Member</td>
                      <td className="justify-left">Individuals with a degree or diploma in Engineering, Technology, or a related field, and at least 10 years of relevant professional experience.</td>
                      <td className="text-end">₹4000</td>
                    </tr>
                    <tr>
                      <td className="serial-number">5</td>
                      <td>Life Fellow</td>
                      <td className="justify-left">Individuals with a degree or diploma in Engineering, Technology, or a related field, and at least 20 years of relevant professional experience. In exceptional cases, the SMART Governing Council may confer this status based on merit.</td>
                      <td className="text-end">₹2500</td>
                    </tr>
                    <tr>
                      <td className="serial-number">6</td>
                      <td>Honorary Fellow</td>
                      <td className="justify-left">Conferred by the SMART Governing Council to distinguished individuals as a mark of honor.</td>
                      <td className="text-end">₹0</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          {/* Loading Overlay */}
          {showLoadingModal && (
            <div className="loading-overlay">
              <div className="loading-container">
                <div className="loading-header">Processing...</div>
                <div className="loading-body">
                  <div className="spinner-border text-primary loading-spinner" role="status"></div>
                  <p className="mt-3">Please wait while we process your registration...</p>
                </div>
              </div>
            </div>
          )}




        </div>
      </section>
      <FooterComponent />


    </>
  )
}
export default withRouter(RegisterComponent);

